import { MultiSelect, SingleSelect } from "@appretio/ui-kit";
import React, { useMemo } from "react";
import type {
  TemporalConfig,
  TemporalContextField,
  TemporalContextOption
} from "./data/temporalContextOptions";
interface TemporalDropdownProps {
  /**
   * Which context field this dropdown is for
   */
  field: TemporalContextField;
  /**
   * Configuration for this temporal context field
   */
  config: TemporalConfig;
  /**
   * Currently selected options for this temporal context field
   */
  selected?: TemporalContextOption<TemporalContextField>;
  /**
   * Sets selected options for this temporal context field
   * @param field - The context field
   * @param value - The selected options
   */
  setSelected: (
    field: TemporalContextField,
    value: string | string[] | undefined
  ) => void;
}

export const TemporalContextDropdown = React.memo(
  ({ field, config, selected, setSelected }: TemporalDropdownProps) => {
    const { label, options, multi } = config;

    // Memoize options transformation for this specific dropdown
    const opts = useMemo(
      () =>
        options.map((opt) => ({
          label: opt.label,
          value: String(opt.value)
        })),
      [options]
    );

    if (multi) {
      const value = Array.isArray(selected) ? selected.map(String) : [];

      return (
        <MultiSelect
          options={opts}
          placeholder={label}
          value={value}
          onChange={(value) => setSelected(field, value)}
        />
      );
    }

    const selectedOption = selected
      ? opts.find((opt) => opt.value === String(selected))
      : undefined;

    return (
      <SingleSelect
        options={opts}
        placeholder={label}
        selectedOption={selectedOption}
        onChange={(value) => setSelected(field, value)}
      />
    );
  }
);
